import { Text } from '@chakra-ui/react';
import { Toggletip } from 'modules/common/components/Toggletip';

import { ReactComponent as InfoIcon } from 'assets/icons/outline_info.svg';

export const AlignmentToggleTip = () => {
  return (
    <Toggletip
      placement='left'
      buttonAriaLabel='Align to tip'
      hasArrow
      icon={<InfoIcon color={'var(--vg-colors-upgrade-500'} />}
      contentStyle={{ width: '12rem', background: 'black' }}
    >
      <Text fontSize='xs' textAlign='left'>
        Select one object to align it to the page. Select multiple objects to align them with each other.
      </Text>
    </Toggletip>
  );
};
